import { Filmomtale, Genre } from '@filmweb/sanity-types';
import Premiere from 'components/film/Premiere';
import SMaxWidthContainer from 'components/framework/SMaxWidthContainer';
import { IMovieArticle } from 'lib/types/sanity';
import styled from 'styled-components';

//#region [Styles]

const SFullFacts = styled(SMaxWidthContainer)`
	text-align: center;
	color: white;
	max-width: 720px;

	@media screen and (min-width: 641px) {
		color: currentColor;
	}


	dd, dt {
		display: inline;
	}

	.newline {
		display: inline-block;
	}

	dd {
		font-weight: var(--font_bold);
		margin-right: .5em;
	}

	div {
		margin-bottom: 30px;
	}
`;


//#endregion

//#region [Props]
type FullFactsProps = {
    filmomtale?: Filmomtale | null;
    document?: IMovieArticle | null;
};
//#endregion

//#region [Component]
export default function FullFacts({ filmomtale, document }: FullFactsProps) {

    const shouldShowAlternativeActorsLabel = (filmomtale?.genres as Genre[])?.some(g => {
        const genreName = g?.name?.toLowerCase() ?? "";
        return genreName === "dokumentar" || genreName === "musikk";
    }) ?? false;

    return (<SFullFacts as="dl">
        <Premiere localPremiere={document?.premiereDate} nationalPremiere={filmomtale?.premiere} />
        {filmomtale && <>
            {filmomtale?.originalTitle?.trim() && <div>
                <dd>Originaltittel:</dd>
                <dt>{filmomtale.originalTitle.trim()}</dt>
            </div>}


            {filmomtale.directorV2 && <div>
                <dd>Regi:</dd>
                <dt>{filmomtale.directorV2}</dt>
            </div>}

            {(filmomtale.originalLanguage?.length ?? 0) > 0 && <div>
                <dd>Språk:</dd>
                <dt>{filmomtale.originalLanguage.join(", ")}</dt>
            </div>}


            {filmomtale.year && <div>
                <dd>Produksjonsår:</dd>
                <dt>{filmomtale.year}</dt>
            </div>}

            {filmomtale.castV2 && <div>
                <dd>{shouldShowAlternativeActorsLabel ? "Medvirkende" : "Skuespillere"}:</dd>
                <dt>{filmomtale.castV2}</dt>
            </div>}

            {(filmomtale.genres?.length ?? 0) > 0 && <div>
                <dd>Sjanger:</dd>
                <dt>{(filmomtale.genres as Genre[]).map(genre => genre.name).join(" / ")}</dt>
            </div>}

            {filmomtale.runningTime && <div>
                <dd>Spilletid:</dd>
                <dt>{filmomtale.runningTime}</dt>
            </div>}

            {(filmomtale.nationality?.length ?? 0) > 0 && <div>
                <dd>Nasjonalitet:</dd>
                <dt>{filmomtale.nationality.join(" / ")}</dt>
            </div>}

            {filmomtale.ageRating?.age && <div>
                <dd>Aldersgrense med begrunnelse:</dd>
                <dt>{filmomtale.ageRating.age} {filmomtale.ageRating.recommendedAge && <>(egnet for {filmomtale.ageRating.recommendedAge})</>}</dt>
                {filmomtale.ageRating.ageReason && <dt className="newline">{filmomtale.ageRating.ageReason}</dt>}
            </div>}

            {filmomtale.productionCompany && <div>
                <dd>Produksjonsselskap:</dd>
                <dt>{filmomtale.productionCompany}</dt>
            </div>}
        </>}
    </SFullFacts>);
}
//#endregion